import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RejectConfirmModal from "../Modals/RejectConfirmModal";
import adaswaplogo from "../assets/images/adaswaplogo.png";
import adaswaplogo2 from "../assets/images/adaswaplogo2.png";
import { faLongArrowAltUp } from "@fortawesome/free-solid-svg-icons";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { Button, Modal, CloseButton } from "react-bootstrap";
import "./ConfirmationModel.css";

function ConfirmationModel() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="model-wraper">
        <Button
          className=" swap--button w-100"
          variant="primary"
          size="lg"
          onClick={handleShow}
        >
          Swap
        </Button>
        <Modal show={show} onHide={handleClose} className="confirmation--model">
          <Modal.Header>
            <div className="w-100">
              <div className="token-text">
                <h4 className="text-left">Swap</h4>
              </div>
            </div>
            <CloseButton variant="white" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-between mb-2 mt-2">
              <div className="d-flex justify-content-center align-items-center">
                <h2>From</h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <h2>0.22 CAO</h2>
                <span className="adaswaplogo">
                  <img src={adaswaplogo} alt="" />
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <div className="d-flex justify-content-center align-items-center">
                <h2>To</h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <h2>9.74 INCH</h2>
                <span className="adaswaplogo">
                  <img src={adaswaplogo2} alt="" />
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <p>
                Output is estimated. If the price changes by more than 0.5% your
                transaction will revert.
              </p>
            </div>
            <div className="d-flex justify-content-between mb-md-5 mb-3">
              <div className="d-flex">
                <h2>Price</h2>
              </div>
              <div className="d-flex">
                <h2>Minimum received</h2>
                <span className="question-icon ms-3">
                  <a href="#" target="_blank">
                    <FontAwesomeIcon icon={faLongArrowAltDown} />
                    <FontAwesomeIcon icon={faLongArrowAltUp} />
                  </a>
                </span>
              </div>
            </div>
            <div className="quantity">
              <div className="d-flex justify-content-between mb-2 ">
                <div className="d-flex">
                  <h2>Minimum received</h2>
                  <span className="question-icon ms-3">
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </a>
                  </span>
                </div>
                <div className="d-flex">
                  <h2>1.289 ASW</h2>
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <div className="d-flex">
                  <h2>Price Impact</h2>
                  <span className="question-icon ms-3">
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </a>
                  </span>
                </div>
                <div className="d-flex">
                  <h2>1.289 ASW</h2>
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <div className="d-flex">
                  <h2>Liquidity Provider Fee</h2>
                  <span className="question-icon ms-3">
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </a>
                  </span>
                </div>
                <div className="d-flex">
                  <h2>0.097 ADA</h2>
                </div>
              </div>
            </div>
            <div className="swap--button-wraper">
              <RejectConfirmModal />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default ConfirmationModel;
